import { useCartContext } from "@/src/context/CartContext";
import { PageHero } from "@/src/components/PageHero";
import { CollectionGrid } from "@/src/pages/collection/(sections)/CollectionGrid";
import { Newsletter } from "@/src/pages/home/(sections)/newsletter/Newsletter";

export function GiftSetsPage() {
    const { addToCart } = useCartContext();

    return (
        <>
            <PageHero
                image="https://images.unsplash.com/photo-1607344645866-009c320b63e0?auto=format&fit=crop&q=80&w=2000"
                label="For every occasion"
                title="Gift Sets"
            />
            <CollectionGrid onAddToCart={addToCart} />
            <Newsletter />
        </>
    );
}
